import React from "react";
import { Link } from "react-router-dom";
import {
  format,
  truncateNumber,
  formatDuration,
} from "../../../utils";
import styles from "./InfoCard.module.css";

export default function InfoCard({
  ind,
  length,
  data,
  image,
  actionText = "Go to item",
  linkUrl,
}) {

  return (
    <div
          className={`${styles.container} ${styles[data.runStatus]}`}
    >
      <img src={image} className={styles.image} alt="" />
      <div className={styles.subContainer}>
        <h2 className={styles.title}>{format(data?.startTimeUtc, "M/d/yy")} </h2>
        
        <div
          className={
            styles.subContainerStats + " " + "bg-stone-50 rounded-2xl w-full"
          }
        >
          <span className="text-zinc-500 text-sm font-normal leading-tight">
            Location :{" "}
          </span>
          <span className="text-black text-sm font-normal leading-tight">
            {data?.location?.name}
            <br />
          </span>
          <span className="text-zinc-500 text-sm font-normal leading-tight">
            Total Area :{" "}
          </span>
          <span className="text-black text-sm font-normal leading-tight">
            {truncateNumber(data?.totalAreaSprayedAcres, 1)} acres
            <br />
          </span>
          <span className="text-zinc-500 text-sm font-normal leading-tight">
            Herbicide Sprayed :{" "}
          </span>
          <span className="text-black text-sm font-normal leading-tight">
            {truncateNumber(data?.totalPesticideSprayedGallons)} gallons
            <br />
          </span>
          <span className="text-zinc-500 text-sm font-normal leading-tight">
            Avg Speed :{" "}
          </span>
          <span className="text-black text-sm font-normal leading-tight">
            {truncateNumber(data?.avgSpeedMph)} mph
            <br />
          </span>
          <span className="text-zinc-500 text-sm font-normal leading-tight">
            Duration :{" "}
          </span>
          <span className="text-black text-sm font-normal leading-tight">
            {formatDuration(data?.duration)}
            <br />
          </span>          
          <span className="text-zinc-500 text-sm font-normal leading-tight">
            Job Count :{" "}
          </span>
          <span className="text-black text-sm font-normal leading-tight">
            {data?.jobCount}
            <br />
          </span>          
        </div>
      </div>
      {linkUrl ? (
        <Link to={linkUrl} className="w-full">
          <button className={styles.button}>{actionText}</button>
        </Link>
      ) : (
        <button className={styles.button}>{actionText}</button>
      )}
    </div>
  );
}
